import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BACKEND_API_BASE_URL;

class DataService {
  getDataByModuleIdAndDate(moduleId, date) {
    return axios.get(API_URL + 'data/module/' + moduleId + '?date=' + date, { headers: authHeader() })
      .then(response => {
        return response.data;
      });
  }

  getDataByModuleIdAndDateRange(moduleId, dateFrom, dateTo) {
    if(dateFrom == dateTo){
      return this.getDataByModuleIdAndDate(moduleId, dateFrom);  
    }
    return axios.get(API_URL + 'data/module/' + moduleId + '?dateFrom=' + dateFrom + '&dateTo=' + dateTo, { headers: authHeader() })
      .then(response => {
        return response.data;
      });
  }

  getLatestDataByModuleId(moduleId) {
    return axios.get(API_URL + 'data/module/' + moduleId + '/latest', { headers: authHeader() })
      .then(response => {
        return response.data;
      });
  }
}

export default new DataService();